import React from 'react'

import stranger from '../../images/STRANGER.png'

function Stranger() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={stranger}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Stranger</h1>
          <p className="Project-text">
            <strong>
            Short Film
            <br />
New Zealand Film Commission
            <br />

Director: Kieran Charnock, Jonathan Watt
            <br />
            2016
            <br />
            <br />

Rehearsal + On Set Acting Coach
            <br />
Coached lead actor (age 5)

            </strong>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Stranger
